export interface StorePrivacySettings {
  enabled: boolean;
  layout: 'card' | 'bar';
  title: string;
  message: string;
  analyticsDescription: string;
  marketingDescription: string;
  retentionDays: number;
}

export const DEFAULT_STORE_PRIVACY: StorePrivacySettings = {
  enabled: false,
  layout: 'card',
  title: 'Twoja prywatność',
  message: 'Używamy niezbędnych cookies do działania sklepu. Za Twoją zgodą użyjemy także cookies analitycznych i marketingowych. Wybór możesz zmienić w dowolnym momencie.',
  analyticsDescription: 'Pomagają nam zrozumieć, jak korzystasz ze sklepu.',
  marketingDescription: 'Pozwalają mierzyć skuteczność reklam i wejść prowadzących do zakupów.',
  retentionDays: 180,
};
